export enum EMenuAdmin {
  CLIENTES = "Clientes",
  USUARIOS = "Usuários",
  VAN_CONFIG = "VanConfig",
  LEAD = "Lead",
  INTEGRACOES = "Integrações",
  REGRAS_CO = "Regras de CO",
  NOTIFICACOES = "Notificações",
  FEATURE_FLAGS = "Feature Flags",
  GESTAO_CONTRATOS = "Gestão de contratos"
}
